<app-view-title [isSplitColor]="true" Title="{{ 'Intellitrailer.MyPage.Settings.TitleSettings' | translate : 'Settings' }}"></app-view-title>
<view-content>
  <h6>{{ 'Intellitrailer.MyPage.Settings.Language' | translate : 'Language' }}</h6>
  <div class="row">
    <mat-form-field appearance="outline">
      <mat-select matNativeControl required [(ngModel)]="language" (selectionChange)="setAsChanged(true)">
        <mat-option *ngFor="let option of languages" [value]="option[0]">
          {{option[1]}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  @if(!userLoggedIn){
  <div class="sign-title logo">
    <button type="button" mat-raised-button (click)="navigate('MyPage.SignIn')">
      <strong>{{ 'Intellitrailer.Menu.SignIn' | translate : 'Sign in' }}</strong>
      <mat-icon>account_box</mat-icon>
    </button>
  </div>
  }
  @if(isLoading){
  <div class="spinner-container">
    <mat-progress-spinner mode="indeterminate" [diameter]="75"></mat-progress-spinner>
  </div>
  }
  @if(customer && !isLoading) {
  <div class="row">
    <div class="col-12" (click)="setAsChanged(true)">
      <app-customer-form-component [(customer)]="customer" (isValidFormChange)="validCustomer"></app-customer-form-component>
      <ng-container>
        <div class="row">
          <div class="col-9">
            <h6>{{ 'Intellitrailer.Booking.Customerform.Offers' | translate: 'Offers' }}</h6>
          </div>
          <div class="col-3 text-right ">
            <mat-slide-toggle class="checkOk" [checked]="customer.ReceivingAdvertising" (change)="toggleAdvertisements($event)"></mat-slide-toggle>
          </div>
          <div class="col-9">
            <p>{{ 'Intellitrailer.Booking.Customerform.AdvertisementsInfo' | translate: 'Switch off to stop receiving promotional emails, discounts, and special offers' }}</p>
          </div>
        </div>
      </ng-container>
      <ng-container>
        <h6>{{ 'Intellitrailer.Booking.Customerform.AccountDetails' | translate: 'Account details' }}</h6>
        <p>{{ 'Intellitrailer.Booking.Customerform.AccountInfo' | translate: 'Your mobile phone and email will be used when signing in to your account in the future.' }}</p>
        <app-customer-details [customer]="customer"></app-customer-details>
      </ng-container>
      <div class="delete-account-btn"><button mat-button (click)="deleteAccount()">Delete my account</button></div>
    </div>
  </div>

  <div>
    <h6>
      {{ 'Intellitrailer.MyPage.Settings.DemoSettigs' | translate : 'Demo settings' }}
      <mat-slide-toggle [checked]="demoSettings" (change)="toggleDemoSettings($event)" class="demo-settings"></mat-slide-toggle>
    </h6>
    @if(demoSettings) {
    <div class="row">
      <div class="col-9">
        <h6>Simulate GPS</h6>
      </div>
      <div class="col-3">
        <mat-slide-toggle [checked]="atLocation" (change)="changeBookingType($event)"></mat-slide-toggle>
      </div>
      <div class="col-9">
        <p>Your position will always be set to whichever location you rent at</p>
      </div>

      <div class="col-9">
        <h6>Simulate unlocking process</h6>
      </div>
      <div class="col-3">
        <mat-slide-toggle [checked]="bypassLock" (change)="changeLockBypass($event)"></mat-slide-toggle>
      </div>
      <div class="col-9">
        <p>The app will simulate the unlocking process. Removing the need to physically be at the lock.</p>
      </div>

      <div class="col-9">
        <h6>Simulate photo</h6>
      </div>
      <div class="col-3">
        <mat-slide-toggle [checked]="demoPhotos" (change)="changePhotoType($event)" class="checkOk"></mat-slide-toggle>
      </div>
      <div class="col-9">
        <p>All photos will be simulated.</p>
      </div>
      @if(Settings.Environment == 0) {
      <div class="col-12" style="text-align: center; padding:15px 0">
        <button mat-stroked-button (click)="openTestVersion()">Test new functionality</button>
      </div>
      <div class="col-12" style="text-align: center; padding:15px 0">
        <button mat-stroked-button (click)="openNewAppService()">Test new payment</button>
      </div>
      }
    </div>
    }
  </div>
  }
</view-content>
<view-actions>
  <button mat-raised-button color="accent" [disabled]="!settingsChanged" (click)="saveChanges()">
    {{ 'Intellitrailer.MyPage.Settings.Save' | translate : 'Save changes' }}
  </button>
</view-actions>

